function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  fill: "#22559E",
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M11.774 31.698h24.452v4.528H11.774v-4.528zM24.453 11.774h3.953L30.34 25.03l1.977-13.256h3.91v18.113H33.62V16.246l-2.195 13.64h-2.251l-2.12-13.64V29.86h-2.602V11.774M17.461 17.962h2.464V16.67c0-1.265 0-4.896-4.121-4.896-4.03 0-4.03 4.146-4.03 4.896v9.51c0 2.776.898 4.595 3.228 4.612 1.377.003 2.337-.97 2.54-1.34v.97l2.383.027v-9.914h-3.876v2.2h1.412v2.898c0 1.468-.407 2.468-1.618 2.468-1.213 0-1.598-1.065-1.598-2.468V16.67c0-.728 0-2.388 1.598-2.388 1.618 0 1.618 1.687 1.618 2.388v1.292"
}));

var Gm = function Gm(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default Gm;